export const useTheme = () => {
    const publicSiteData = useState('publicSiteData');
    
    const themes = {
        blue: {
            dark: '#0E2140',
            medium: '#3658C8',
            light: '#E4F6FC',
            bg: '#0E2140',
            headerGradient: '#0E2140',
            buttonText: '#FFFFFF',
            outlineButtonText: '#3658C8',
            linkText: '#3658C8',
            linkHover: '#0E2140'
        },
        yellow: {
            dark: '#6F4F31',
            medium: '#FFAE36',
            light: '#FFF5E7',
            bg: '#6F4F31',
            headerGradient: '#6F4F31',
            buttonText: '#6F4F31',
            outlineButtonText: '#6F4F31',
            linkText: '#6F4F31',
            linkHover: '#FFAE36'
        },
        green: {
            dark: '#105652',
            medium: '#038E7A',
            light: '#D8F8EA',
            bg: '#105652',
            headerGradient: '#105652',
            buttonText: '#FFFFFF',
            outlineButtonText: '#105652',
            linkText: '#105652',
            linkHover: '#038E7A'
        },
        orange: {
            dark: '#6E2E41',
            medium: '#FF6A3D',
            light: '#FFE7E2',
            bg: '#6E2E41',
            headerGradient: '#6E3D2E',
            buttonText: '#FFFFFF',
            outlineButtonText: '#6E2E41',
            linkText: '#6E2E41',
            linkHover: '#FF6A3D'
        }
    };
    
    const theme = computed(() => {
        const themeName = publicSiteData.value?.theme || 'blue';
        return themes[themeName] || themes.blue;
    });
    
    return {
        theme,
        themeColors: theme
    };
};